<div class="modal-wrapper">
  <img src="../../../assets/img/monnaie.png" alt="provider icon" />
  <h2 class="tarif">{{ tarif }}€</h2>
  <p>
    {{ "SELECT_PAYMENT_MODAL.WITHDRAW_MODAL.PRELEVE" | translate }}
    {{ tarif }}€ {{ "SELECT_PAYMENT_MODAL.WITHDRAW_MODAL.SUCCECC" | translate }}
  </p>
  <div class="modal-wrapper__buttons">
    <app-button
      (onClick)="closeModal()"
      [innerText]="'SELECT_PAYMENT_MODAL.WITHDRAW_MODAL.CONTINUER' | translate"
    ></app-button>
  </div>
</div>
